const STORAGE_KEY = 'pickens_first_touch';
const ATTRIBUTION_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

function clean(value) {
  return String(value || '').trim().slice(0, 120);
}

function readStored() {
  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
  } catch (_error) {
    return null;
  }
}

function writeStored(value) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (_error) {
    // Attribution is optional; forms continue to work if storage is unavailable.
  }
}

const params = new URLSearchParams(window.location.search);
const campaign = ATTRIBUTION_KEYS.reduce((result, key) => {
  const value = clean(params.get(key));
  if (value) result[key] = value;
  return result;
}, {});

let attribution = readStored();

if (!attribution || Object.keys(campaign).length > 0) {
  attribution = {
    ...campaign,
    landing_page: clean(`${window.location.pathname}${window.location.search}`),
    referrer: clean(document.referrer) || 'Direct',
  };
  writeStored(attribution);
}

window.PickensAttribution = attribution || {
  landing_page: clean(window.location.pathname),
  referrer: clean(document.referrer) || 'Direct',
};
